"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require("@angular/core");
var NgTranscludeDirective = (function () {
    function NgTranscludeDirective(_viewRef) {
        this.viewRef = _viewRef;
    }
    NgTranscludeDirective.prototype.ngOnChanges = function (changes) {
        if (changes.ngTransclude) {
            this._createEmbeddedView(changes.ngTransclude.currentValue);
        }
    };
    NgTranscludeDirective.prototype.ngAfterViewInit = function () {
        this._createEmbeddedView(this.ngTransclude);
    };
    NgTranscludeDirective.prototype._createEmbeddedView = function (viewRef) {
        if (viewRef) {
            this.viewRef.createEmbeddedView(viewRef);
        }
    };
    return NgTranscludeDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", core_1.TemplateRef)
], NgTranscludeDirective.prototype, "ngTransclude", void 0);
NgTranscludeDirective = __decorate([
    core_1.Directive({
        selector: '[ngTransclude]',
    }),
    __param(0, core_1.Inject(core_1.ViewContainerRef)),
    __metadata("design:paramtypes", [core_1.ViewContainerRef])
], NgTranscludeDirective);
exports.NgTranscludeDirective = NgTranscludeDirective;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/common.js
// module id = 34
// module chunks = 0